import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

// 1) Zkusit uložený jazyk (store/cookie/localStorage)
function getSavedLocale() {
  try {
    return localStorage.getItem("locale");
    // nebo cookie: return Vue.$cookies.get("locale");
    // nebo Vuex store: store.state.locale
  } catch {
    return null;
  }
}

// 2) Zkusit jazyk prohlížeče
function getBrowserLocale() {
  const lang = (navigator.language || navigator.userLanguage || "").split("-")[0];
  return lang || null;
}

export default new VueI18n({
  locale: getSavedLocale() || getBrowserLocale() || process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "cs",
  messages: loadLocaleMessages(),
});
